import { useEffect } from 'react';

export function useOnClickOutside(handler: () => void) {
	useEffect(() => {
		const listener = event => {
			const notificationDrawer = document.getElementById('notification-drawer');

			if (notificationDrawer === null) {
				return; // Do nothing if clicking ref's element or descendent elements
			}
			const settingsDrawer = document.getElementById('settings-drawer');

			if (
				(settingsDrawer !== null && settingsDrawer.contains(event.target)) ||
				notificationDrawer.contains(event.target)
			) {
				return; // Do nothing if clicking ref's element or descendent elements
			}

			handler();
		};
		document.addEventListener('mousedown', listener);
		document.addEventListener('touchstart', listener);

		return () => {
			document.removeEventListener('mousedown', listener);
			document.removeEventListener('touchstart', listener);
		};
	}, [handler]);
}
